<template>
  <b-modal size="sm" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">
    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" " :error="$v.form.descricao"
            v-model="form.descricao" label="Descrição:*" cols="12" sm="12" />

          <b-form-group label="Status:*" class="ml-3">
            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
              name="status-inline"></b-form-radio-group>
          </b-form-group>

        </b-form-row>


        <b-form-row>

          <b-col cols="3"></b-col>
          <b-col cols="6" class="text-center">
            <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success" @click="save">
              <b-icon icon="check-circle" />
              <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

            </b-button>

            <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
              <b-icon icon="x-circle" />
              <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

            </b-button>
          </b-col>
          <b-col cols="3"></b-col>

        </b-form-row>

      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import ConfirmMixin from "@/core/mixins/confirm"
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
  },
  props: {
    id: Number,
    prefix: {
      type: String,
      default: "",
    },

  },
  mixins: [FormResourceMixin, ConfirmMixin],

  validations: {
    form: {
      descricao: { required },
      situacao: { required },
    },
  },
  data() {
    return {
      statusOptions: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],

      showModal: true,
      title: " Cadastro",
      form: {
        descricao: "",
        situacao: 1,
      },
    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/tipo-problema`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    }
  },
  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        });
        return;
      }

      await this.$saveResource(this.form);
      this.cancelar();
    },
    cancelar() {
      this.showModal = false;
      this.$emit("close");

    }
  },
};
</script>
